import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import WarningIcon from '@material-ui/icons/Warning';
import BuildIcon from '@material-ui/icons/Build';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { caseStudy } from '../cherrySoftwareContent';
import { CaseStudyIllustration } from './cherrySoftwareIllustrations';
import SectionHeader from './SectionHeader';
import GlassCard from './GlassCard';

const CaseStudy = () => {
  const theme = useTheme();
  const { item } = caseStudy;

  const blocks = [
    {
      label: 'El Reto',
      text: item.challenge,
      icon: WarningIcon,
      color: theme.palette.warning.main,
      bg: alpha(theme.palette.warning.main, 0.07),
    },
    {
      label: 'La Solución',
      text: item.solution,
      icon: BuildIcon,
      color: theme.palette.primary.main,
      bg: alpha(theme.palette.primary.main, 0.07),
    },
    {
      label: 'El Resultado',
      text: item.result,
      icon: CheckCircleOutlineIcon,
      color: theme.palette.success.main,
      bg: alpha(theme.palette.success.main, 0.07),
    },
  ];

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <Grid container spacing={4} alignItems="center" mb={{ xs: 2, md: 4 }}>
        <Grid item xs={12} md={8}>
          <SectionHeader
            overline={caseStudy.overline}
            title={caseStudy.title}
            subtitle={caseStudy.subtitle}
            icon="assignment"
            align="left"
            maxWidth="100%"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Box data-aos="fade-left" display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }}>
            <CaseStudyIllustration
              primary={theme.palette.primary.main}
              secondary={theme.palette.secondary.main}
            />
          </Box>
        </Grid>
      </Grid>

      <Box data-aos="fade-up" width="100%">
        <GlassCard hover={false}>
          <Box
            px={{ xs: 3, md: 4 }}
            py={3}
            borderBottom={`1px solid ${theme.palette.divider}`}
            sx={{
              background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.06)} 0%, ${alpha(theme.palette.secondary.main, 0.06)} 100%)`,
            }}
          >
            <Typography variant="overline" color="textSecondary" sx={{ fontWeight: 700 }}>
              Proyecto
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 800, mt: 0.5 }}>
              {item.project}
            </Typography>
          </Box>
          <Grid container>
            {blocks.map((block) => {
              const Icon = block.icon;
              return (
                <Grid item xs={12} md={4} key={block.label}>
                  <Box
                    sx={{
                      p: { xs: 3, md: 3.5 },
                      height: '100%',
                      bgcolor: block.bg,
                      borderRight: { md: `1px solid ${theme.palette.divider}` },
                      borderBottom: { xs: `1px solid ${theme.palette.divider}`, md: 'none' },
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: '10px',
                          display: 'grid',
                          placeItems: 'center',
                          bgcolor: alpha(block.color, 0.12),
                          color: block.color,
                        }}
                      >
                        <Icon sx={{ fontSize: 20 }} />
                      </Box>
                      <Typography variant="overline" sx={{ fontWeight: 800 }}>
                        {block.label}
                      </Typography>
                    </Box>
                    <Typography sx={{ lineHeight: 1.75 }}>{block.text}</Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </GlassCard>
      </Box>
    </Box>
  );
};

export default CaseStudy;
